<div id="mapf"></div>

<div id="popupf" >
    <!--Habilitar CERRAR PopUP    -->
    <!--  -->
    <div *ngIf="infoLoteFromMapbox">
      <h5 class="text-center" style="font-size:16px; padding-top:">{{infoLoteFromMapbox.nroficha}}</h5>
      <h3 class="text-center" style="font-size:14px; color:#820E42;">Dirección: {{infoLoteFromMapbox.direccion}}</h3>
      <!-- <img src="assets/img/secciones/inmaterial/{{infoLoteFromMapbox.codregistr}}.jpg" class="img-fluid" /> -->
      <!--<p>{{infoElementoPuntos.codregistro}}</p>-->
      <p><img
        src="{{urlWebServer}}/registrofotografico/{{infoLoteFromMapbox.nroficha | slice : 0 : 10 }}/arquitectonica/registro_fotograficos/F21.jpg"
        width=200><img
        src="{{urlWebServer}}/registrofotografico/{{infoLoteFromMapbox.nroficha | slice : 0 : 10 }}/arquitectonica/registro_fotograficos/M01.jpg"
        width=200></p>
      <button class="btn btn-primary btn-sm btn-01-color-gchc btn-block"
        (click)="cargarFicha(infoLoteFromMapbox.nroficha)"><i class="fa fa-eye mx-1"
          aria-hidden="true"></i>ver más</button>

    </div>
  </div>
